import React from 'react';
import { TagIcon, CircleInfoIcon } from '@revfluence/fresh-icons/solid/esm';
import { Skeleton } from '@/shadcn/components/ui/skeleton';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shadcn/components/ui/tooltip';
import { BrandMentionsProps } from './useBrandMentionsProps';

export const BrandMentionsSection: React.FC<BrandMentionsProps> = ({
  isLoading,
  brands,
  hasData,
}) => {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <Skeleton className="w-6 h-6 rounded-lg" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="w-4 h-4" />
        </div>
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} className="w-12 h-12 rounded-lg" />
          ))}
        </div>
      </div>
    );
  }

  if (!hasData) {
    return (
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-lime-3 rounded-lg flex justify-center items-center">
            <TagIcon className="w-3 h-3 text-white" />
          </div>
          <div className="text-grey-6 text-sm font-medium">Brand Mentions</div>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="w-4 h-4 flex justify-center items-center">
                <CircleInfoIcon className="w-4 h-4 text-grey-4" />
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>Brands mentioned in this creator's content</p>
            </TooltipContent>
          </Tooltip>
        </div>
        <div className="text-grey-5 text-sm">No brand mentions available</div>
      </div>
    );
  }

  const displayBrands = brands.slice(0, 15);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-lime-3 rounded-lg flex justify-center items-center">
          <TagIcon className="w-3 h-3 text-white" />
        </div>
        <div className="text-grey-6 text-sm font-medium">Brand Mentions</div>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="w-4 h-4 flex justify-center items-center">
              <CircleInfoIcon className="w-4 h-4 text-grey-4" />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>Brands mentioned in this creator's content</p>
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="flex flex-wrap gap-2">
        {displayBrands.map((brand) => (
          <Tooltip key={brand.username}>
            <TooltipTrigger asChild>
              <img
                className="w-12 h-12 rounded-lg border border-grey-2"
                src={brand.logo_url}
                alt={brand.name}
              />
            </TooltipTrigger>
            <TooltipContent>
              <div>
                <p className="font-medium">{brand.name}</p>
                <p className="text-xs text-grey-5">{brand.mention_count} mentions</p>
              </div>
            </TooltipContent>
          </Tooltip>
        ))}
        {brands.length > 15 && (
          <div className="w-12 h-12 rounded-lg border border-grey-2 bg-grey-1 flex items-center justify-center">
            <span className="text-xs font-medium text-grey-5">+{brands.length - 15}</span>
          </div>
        )}
      </div>
    </div>
  );
};
